/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {BaseComponent} from 'compob2b-libs';
import {takeUntil} from 'rxjs/operators';
import {AuthError, AuthStateService} from '../services/auth-state.service';
import {AuthService} from '../services/auth.service';

@Component({
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export abstract class SignInComponent extends BaseComponent implements OnInit {

  loginForm = new UntypedFormGroup({
    login: new UntypedFormControl('', [Validators.required, Validators.minLength(4)]),
    password: new UntypedFormControl('', [Validators.required, Validators.minLength(6)]),
    remember: new UntypedFormControl(false)
  });

  constructor(private readonly userService: AuthService,
              private readonly stateService: AuthStateService) {
    super();
  }

  ngOnInit() {
    // Ошибки входа показываем тостами, а не постоянными алёртами.
    this.stateService.errors.pipe(takeUntil(this.unsubscribe))
      .subscribe(error => this.showAuthError(error));
  }

  private showAuthError(error: AuthError): void {
    switch (error) {
      case 'server':
        this.errorToast($localize`:@@LoginServerError:Возникла ошибка. Попробуйте позже`);
        break;
      case 'locked':
        this.errorToast($localize`:@@LoginLockedError:Временная блокировка. Вы ввели неверные данные 5 раз. Попробуйте позже`);
        break;
      case 'forbidden':
        this.errorToast($localize`:@@LoginPassIncorrect:Неверно указан логин и/или пароль`);
        break;
    }
  }

  onSubmit(): void {
    if (this.loginForm.valid) {
      this.userService.signIn(this.loginForm.value).subscribe(_ => this.afterSignIn());
    }
  }

  afterSignIn(): void {
  }

}
